/**
 * Log google analytics events
 * Check for gtag being available,
 * it might be blocked by ad blocker.
 * @param {string} category event category
 * @param {action} action event action
 * @param {label} label event label
 * @returns void
 */

import { isBrowser } from "../../utils/browser"

export const logEvent = (category, action, label) => {
  if (!isBrowser || !window.gtag || (!category && !action && !label)) return

  console.log(
    `Logging event for category: ${category}, action: ${action}, label: ${label}`
  )
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
  })
}
